import React from 'react'
import './Banner.scss';
import phones from '../../phones.png';

function Banner() {
    return (
        <div id='banner'>
            <div className='bannerContainer row'>
                    <div className='col-lg'>
                        <h1>#1 sports betting service with education, odds/picks from elite handicappers.</h1>
                        <h2>We built an experienced and dedicated team to offer what we believe no other company does. Trustworthy sports picks built around compassion, dedication and clarity.</h2>
                        <div className="button-group mt-4">
                            <a className="btn buyButton" href="#pricing" role="button">Buy Now</a>
                            <a className="btn learnButton" href="#about" role="button">Learn More</a>
                        </div>
                    </div>
                    <div className='col-lg col-center'>
                        <img className="phones" src={phones} alt="phones" />
                    </div>
            </div>
        </div>
    )
}

export default Banner
